<template>
  <div class="tab-content" id="PTtab-5" :key="'PTtab-5'">
    <ul class="tablist">
      <li class="tabmenu current" @click="onChangeTab('partnerCashList')">{{ $t('front.mypage.depositWithdrawalList') }}</li>
      <li class="tabmenu" @click="onChangeTab('partnerMoneyMoveList')">{{ $t('front.stributor.m5') }}/{{ $t('front.common.retriDetail') }}</li>
    </ul>
    <div class="pagenamPT">
      <h3 class="pagename2">{{ $t('front.mypage.depositWithdrawalList') }}</h3>
    </div>
    <div class="sch_PC">
      <div class="PTsch flex-c">
        <div class="datesearchPTWarp flex-c gap-2">
          <h4>{{ $t('front.give.date') }}</h4>
          <date-filter :retail="true" @search="loadData(null, 1)"
                        @update="onChangeDateTable"
                        :defaultDay="0"
                        :startDate="mainTableDate.startDate"
                        :endDate="mainTableDate.endDate"
                        :isOldYn="true"
                        :id="'main-date-checkbox1'"
                        @setOldYn="setOldYn" :oldYn="reqData.oldYn" />
        </div>
      </div>
    </div>
    <div class="sch_M">
      <div class="PTsch flex-c">
        <div class="datesearchM">
          <date-filter-mobile :retail="true" @search="loadData(null, 1)"
                              @update="onChangeDateTable"
                              :defaultDay="0"
                              :startDate="mainTableDate.startDate"
                              :endDate="mainTableDate.endDate"
                              :isOldYn="true"
                              :id="'main-date-checkbox1'"
                              @setOldYn="setOldYn" :oldYn="reqData.oldYn"
          />
        </div>
      </div>
    </div>
    <div class="sch_Normal">
      <div class="sch_Btm">
        <div class="searchPTwrap">
          <div class="searchPT">
            <div class="datesearchPT flex-c gap-2">
              <h4>{{ $t('front.board.kind') }}</h4>
              <select  v-model="reqData.cashType" class="h36px">
                <option value="" selected>{{ $t('front.gameCategory.all') }}</option>
                <option value="1">{{ $t('front.common.deposit') }}</option>
                <option value="-1">{{ $t('front.common.withdrawal') }}</option>
                <option value="2">{{ $t('front.common.managerPay') }}</option>
                <option value="-2">{{ $t('front.common.managerRetri') }}</option>
                <option value="33">{{ $t('front.common.upper') }}</option>
                <option value="-33">{{ $t('front.common.upperRetri') }}</option>
                <option value="4">{{ $t('front.point.pointTrans') }}</option>
              </select>
            </div>
            <div class="datesearchPT flex-c gap-2">
              <h4>{{ $t('front.board.type') }}</h4>
              <select  v-model="reqData.searchType" class="h36px">
                <option value="memId" selected>{{ $t('front.common.memId') }}</option>
                <option value="memNick">{{ $t('front.common.nickName') }}</option>
                <option value="recommenderId">{{ $t('front.common.topUser') }}</option>
              </select>
            </div>
          </div>
          <div class="searchPT">
            <input type="text" :placeholder="$t('front.search.emptySearch')"  v-model="reqData.searchWord" class="h36px"/>
            <a @click="loadData(null,1)" class="sch_Icon">
              <img src="@/assets/img/search.png" alt=""/>
            </a>
          </div>
        </div>
        <div class="searchPTwrap">
          <div class="datesearchPT flex-c gap-2 w30p">
            <h4>{{ $t('front.common.order') }}</h4>
            <select v-model="orderStr" class="h36px">
              <option value="preCashAmt_DESC">{{ $t('front.common.largeProcess') }}</option>
              <option value="preCashAmt_ASC">{{ $t('front.common.smallProcess') }}</option>
              <!-- <option value="cashAmt_DESC">처리금액 많은순</option>
              <option value="cashAmt_ASC">처리금액 적은순</option> -->
              <option value="regDate_ASC">{{ $t('front.common.Appliearliest') }}</option>
              <option value="regDate_DESC">{{ $t('front.common.Applilatest') }}</option>
              <option value="updDate_ASC">{{ $t('front.common.processEarly') }}</option>
              <option value="updDate_DESC">{{ $t('front.common.processLatest') }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <!-- 모바일 트리구조 -->
    <div class="cashTreeMobileBtn" @click="cashTreeOpen = !cashTreeOpen">
      전체 파트너 목록 보기
    </div>
    <div class="strTableWrap">
      <div :class="['subMemWrap', 'cashTreeWrap', { open: cashTreeOpen }]">
        <p class="p10"></p>
        <ul class="subPT_1">
          <h3>
            {{ $t('front.common.lowerPartnerList') }}
            <a class="allBtn pd-x-5" @click="loadData(userData.memId, 1)">{{ $t('front.common.fullList') }}</a>
            <!-- <a @click="idlist=!idlist">i</a> -->
            <span v-if="idlist" @click="idlist=!idlist">아이디 클릭시 목록 출력</span>
          </h3>
          <!-- <li>
            <a>
              <span class="box" :class="userData.partnerLevel">{{partnerLevelName(userData.partnerLevel)}}</span>
              {{userData.memId}}
            </a>
          </li> -->
          <li v-for="(item1) in partnerList" :key="item1.memId" :class="{'morebar':item1.open}">
            <span class="arr" v-if="item1.cnt" :class="[item1.partnerLevel, {'moreOn':item1.open}]" @click="listOpen(item1.memId, 'sub', item1)"></span>
            <span class="arr normal" v-if="!item1.cnt"></span>
            <a :class="[item1.partnerLevel, { 'active': selectedLi === item1.memId }]" @click="getMyPartnerList(item1.memId, 'sub', item1)">
              <span class="box" :class="item1.partnerLevel">{{ $t('front.common.hq') }}</span>
              {{item1.memId}}
            </a>

            <ul class="subPT_2" v-show="item1.open && item1.children">
              <li v-for="item2 in item1.children" :key="item2.memId" :class="{'morebar':item2.open}">
                <span class="arr" v-if="item2.cnt" :class="[item2.partnerLevel,{'moreOn':item2.open}]" @click="listOpen(item2.memId, 'sub', item2)"></span>
                <span class="arr normal" v-if="!item2.cnt"></span>
                <a :class="[item2.partnerLevel, { 'active': selectedLi === item2.memId }]" @click="getMyPartnerList(item2.memId, 'sub', item2)">
                  <span class="box" :class="item2.partnerLevel">{{ $t('front.common.cp') }}</span>
                  {{item2.memId}}
                </a>

                <ul class="subPT_3" v-show="item2.open && item2.children">
                  <li v-for="item3 in item2.children" :key="item3.memId" :class="{'morebar':item3.open}">
                    <span class="arr" v-if="item3.cnt" :class="[item3.partnerLevel,{'moreOn':item3.open}]" @click="listOpen(item3.memId, 'sub', item3)"></span>
                    <span class="arr normal" v-if="!item3.cnt"></span>
                    <a :class="[item3.partnerLevel, { 'active': selectedLi === item3.memId }]" @click="getMyPartnerList(item3.memId, 'sub', item3)">
                      <span class="box" :class="item3.partnerLevel">{{ $t(partnerLevelName(item3.partnerLevel)) }}</span>
                      {{item3.memId}}
                    </a>

                    <ul class="subPT_4" v-show="item3.open && item3.children">
                      <li v-for="item4 in item3.children" :key="item4.memId" :class="{'morebar':item4.open}">
                        <span class="arr" v-if="item4.cnt" :class="[item4.partnerLevel,{'moreOn':item4.open}]" @click="listOpen(item4.memId, 'sub', item4)"></span>
                        <span class="arr normal" v-if="!item4.cnt"></span>
                        <a :class="[item4.partnerLevel, { 'active': selectedLi === item4.memId }]" @click="getMyPartnerList(item4.memId, 'sub', item4)">
                          <span class="box" :class="item4.partnerLevel">{{ $t(partnerLevelName(item4.partnerLevel)) }}</span>
                          {{item4.memId}}
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
        <!-- <ul class="subPT_1">
          <template v-for="(item1) in partnerList" :key="item1.memId">
            <li>
              <span v-if="item1.cnt" :class="{'moreOn':item1.children && item1.children.length > 0}" class="arr">▶</span>
              <a :class="[item1.partnerLevel, { 'active': selectedLi === item1.memId }]" @click="getMyPartnerList(item1.memId, 'sub', item1)">
                <span class="box" :class="item1.partnerLevel">{{partnerLevelName(item1.partnerLevel)}}</span>
                {{item1.memId}}
              </a>
              <ul class="subPT_2" v-show="item1.open && item1.children">
                <template v-for="(item2) in item1.children" :key="item2.memId">
                  <li>
                    <span v-if="item2.cnt" :class="{'moreOn':item2.children && item2.children.length > 0}" class="arr">▶</span>
                    <a :class="[item2.partnerLevel, { 'active': selectedLi === item2.memId }]" @click="getMyPartnerList(item2.memId, 'sub', item2)">
                      <span class="box" :class="item2.partnerLevel">{{partnerLevelName(item2.partnerLevel)}}</span>
                      {{item2.memId}}
                    </a>
                    <ul class="subPT_3" v-show="item2.open && item2.children">
                      <template v-for="(item3) in item2.children" :key="item3.memId">
                        <li>
                          <span v-if="item3.cnt" :class="{'moreOn':item3.children && item3.children.length > 0}" class="arr">▶</span>
                          <a :class="[item3.partnerLevel, { 'active': selectedLi === item3.memId }]" @click="getMyPartnerList(item3.memId, 'sub', item3)">
                            <span class="box" :class="item3.partnerLevel">{{partnerLevelName(item3.partnerLevel)}}</span>
                            {{item3.memId}}
                          </a>
                          <ul class="subPT_4" v-show="item3.open && item3.children">
                            <template v-for="(item4) in item3.children" :key="item4.memId">
                              <li>
                                <span v-if="item4.cnt" :class="{'moreOn':item4.children && item4.children.length > 0}" class="arr">▶</span>
                                <a :class="[item4.partnerLevel, { 'active': selectedLi === item4.memId }]" @click="getMyPartnerList(item4.memId, 'sub', item4)">
                                  <span class="box" :class="item4.partnerLevel">{{partnerLevelName(item4.partnerLevel)}}</span>
                                  {{item4.memId}}
                                </a>
                              </li>
                            </template>
                          </ul>
                        </li>
                      </template>
                    </ul>
                  </li>
                </template>
              </ul>
            </li>
          </template>
        </ul> -->
      </div>
      <div class="strTablescr">
        <div class="strTablePC">
          <table class="strTablePT">
            <colgroup>
              <col style="width:9%;">
              <col style="width:11%;">
              <col style="width:6%;">
              <col style="width:10%;">
              <col style="width:10%;">
              <col style="width:10%;">
              <col style="width:10%;">
              <col style="width:10%;">
              <col style="width:13%;">
              <col style="width:13%;">
            </colgroup>
            <thead>
              <tr>
                <th>{{ $t('front.common.memId') }}</th>
                <th>{{ $t('front.common.nickName') }}</th>
                <th>{{ $t('front.common.rank') }}</th>
                <th>{{ $t('front.common.department') }}</th>
                <th>{{ $t('front.board.kind') }}</th>
                <!-- <th>상위아이디</th> -->
                <th>{{ $t('front.common.beforeProcess') }}</th>
                <th>{{ $t('front.common.processingAmount') }}</th>
                <th>{{ $t('front.common.afterProcess') }}</th>
                <th>{{ $t('front.common.appliedTime') }}</th>
                <th>{{ $t('front.common.processTime') }}</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="cashList.length > 0">
                <template v-for="(item, idx) in cashList" :key="item.updDate + idx">
                  <tr>
                    <td>{{item.memId}}</td>
                    <td><span class="nick">{{item.memNick}}</span></td>
                    <td>
                      <span class="box" :class="item.myLevel">{{ partnerLevelName(item.myLevel) }}</span>
                    </td>
                    <td>
                      <div class="topwrap" v-if="item.topUserList && item.topUserList.length > 0 && item.topUserList !== '0'">
                        <select class="h20 upperUser">
                          <option v-for="pt in item.topUserList.slice(0, 1)" :key="pt.recommenderId">
                              <span>[{{ $t(pt.partnerLevelName) }}] </span>
                              <span>{{pt.recommenderId}}</span>
                          </option>
                        </select>
                        <i class="icon" @click="onOpenRate(item)">+</i>
                      </div>
                      <div v-else>
                        -
                      </div>
                    </td>
                    <td>{{item.cashDesc}}</td>
                    <td>{{thousand(item.preCashAmt)}}</td>
                    <td :class="{'minusAmt' : item.cashDesc === '환전', 'plusAmt' : item.cashDesc === '충전', }">{{thousand(item.cashAmt.replace('-', ''))}}</td>
                    <td>{{thousand(item.cashAmt-(-item.preCashAmt))}}</td>
                    <td>{{dateFormatAll(item.regDate)}}</td>
                    <td>{{dateFormatAll(item.updDate)}}</td>
                  </tr>
                </template>
              </template>
              <template v-else>
                <tr>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      <div class="cashCardM">
        <template v-if="cashList.length > 0">
          <div class="cashCard" v-for="(item, idx) in cashList" :key="item.updDate + idx">
            <div class="cashCardHead">
              <div>
                <strong>{{ item.memId }}</strong>
                <span>{{ item.memNick }}</span>
              </div>
              <span class="box" :class="item.myLevel">
                {{ partnerLevelName(item.myLevel) }}
              </span>
            </div>

            <div class="cashCardBody">
              <div class="row">
                <em>소속</em>
                <div class="topwrap" v-if="item.topUserList && item.topUserList.length > 0 && item.topUserList !== '0'">
                  <select class="h20 upperUser mw-auto">
                    <option v-for="pt in item.topUserList.slice(0, 1)" :key="pt.recommenderId">
                      [{{ $t(pt.partnerLevelName) }}] {{ pt.recommenderId }}
                    </option>
                  </select>
                  <i class="icon" @click="onOpenRate(item)">+</i>
                </div>
                <span v-else>-</span>
              </div>

              <div class="row">
                <em>구분</em>
                <span>{{ item.cashDesc }}</span>
              </div>

              <div class="row">
                <em>처리 전</em>
                <span>{{ thousand(item.preCashAmt) }}</span>
              </div>

              <div class="row">
                <em>처리 금액</em>
                <span :class="{'minusAmt' : item.cashDesc === '환전', 'plusAmt' : item.cashDesc === '충전'}">
                  {{ thousand(item.cashAmt.replace('-', '')) }}
                </span>
              </div>

              <div class="row">
                <em>처리 후</em>
                <span>{{ thousand(item.cashAmt - (-item.preCashAmt)) }}</span>
              </div>

              <div class="row">
                <em>신청 시각</em>
                <span>{{ dateFormatAll(item.regDate) }}</span>
              </div>

              <div class="row">
                <em>처리 시각</em>
                <span>{{ dateFormatAll(item.updDate) }}</span>
              </div>
            </div>
          </div>
        </template>

        <div class="cashCardEmpty" v-else>
          내역 없음
        </div>
      </div>
    </div>
    </div>
    <pagination v-if="pageInfo"
                :pageNum="pageInfo.page"
                :pageSize="pageInfo.count_per_list"
                :totalCount="pageInfo.tatal_list_count"
                :className="'partnerPaging'"
                @goToPage="goToPage"
    />
    <transition name="fade">
      <RateTable v-show="RateOpen" :isOpen="onOpenRate" @close="onClosePay"/>
    </transition>
  </div>
</template>

<script>
import DateFilter from '@/components/ui/DateFilter'
import DateFilterMobile from '@/components/ui/DateFilterMobile'
import RateTable from '@/components/common/RateTable.vue'
import Pagination from '@/components/ui/Pagination.vue'
import { getDateStr, thousand } from '@/libs/utils'
import { addDays } from 'date-fns'
import { mapState } from 'vuex'
import { partnerLevels, retailMyPartnerCashList, retailMyPartnerDirectList } from '@/api/retail'
import { PARTNER_LEVEL_NAME } from '@/libs/constants'
export default {
  name: 'PartnerCash',
  components: { DateFilter, DateFilterMobile, Pagination, RateTable },
  computed: {
    ...mapState([
      'userData',
      'gameCount',
      'commonCodeByOrder',
      'commonCodeByCode'
    ])
  },
  data () {
    return {
      mainTableDate: {
        startDate: getDateStr(addDays(new Date(), 0), 'yyyy-MM-dd 00:00:00'),
        endDate: getDateStr(addDays(new Date(), 0), 'yyyy-MM-dd 23:59:59')
      },
      reqData: {
        memId: '',
        cashType: '',
        searchType: '',
        searchWord: '',
        startDate: '',
        endDate: '',
        oldYn: 'N'
      },
      cashTreeOpen: false,
      partnerList: [],
      cashList: [],
      selectedLi: null,
      idlist: false,
      RateOpen: false,
      orderStr: ''
    }
  },
  async created () {
    this.emitter.emit('Loading', true)
    this.getPartnerLevels()
    this.getMyPartnerList(this.userData.memId)
    this.reqData.startDate = getDateStr(new Date(this.mainTableDate.startDate))
    this.reqData.endDate = getDateStr(new Date(this.mainTableDate.endDate))
    await this.loadData(this.userData.memId, 1)
    this.emitter.emit('Loading', false)
  },
  watch: {
    orderStr () {
      this.loadData(this.userData.memId, 1)
    }
  },
  methods: {
    onClosePay () {
      this.RateOpen = false
    },
    onOpenRate () {
      this.RateOpen = true
    },
    thousand,
    goToPage (page) {
      this.loadData(this.selectedLi, page)
    },
    setOldYn (data) {
      this.reqData.oldYn = data
    },
    partnerLevelName (partnerLevel) {
      return PARTNER_LEVEL_NAME[partnerLevel]
    },
    onChangeTab (name, param) {
      if (param && param.code) {
        this.currentTab = param.code
      } else {
        this.currentTab = name
      }
      this.goPageByName(name, param)
    },
    listOpen (memId, type, item) {
      this.emitter.emit('Loading', true)
      const params = {
        memId: memId
      }
      retailMyPartnerDirectList(params).then(res => {
        const result = res.data
        if (result.resultCode === '0') {
          const list = result.data.list
          if (type === 'sub') {
            item.children = list
            item.open = !item.open
          } else {
            this.partnerList = list
          }
        }
        this.emitter.emit('Loading', false)
      })
    },
    getMyPartnerList (memId, type, item) {
      this.emitter.emit('Loading', true)
      if (window.innerWidth <= 1000) {
        this.cashTreeOpen = false
      }
      const params = {
        memId: memId
      }
      retailMyPartnerDirectList(params, type).then(res => {
        const result = res.data
        if (result.resultCode === '0') {
          const list = result.data.list
          if (type === 'sub') {
            item.children = list

            if (this.selectedLi === memId) {
              this.selectedLi = memId
            } else {
              this.selectedLi = memId
            }

            this.loadData(memId, 1, type)
          } else {
            this.partnerList = list
          }
        }
        this.emitter.emit('Loading', false)
      })
    },
    getPartnerLevels () {
      partnerLevels({}).then(res => {
        const result = res.data
        if (result.resultCode === '0') {
          this.partnerLevelList = result.data.list
          this.newPartnerLevel = result.data.list[0]
          const partnerObj = {}
          for (let i = 0; i < this.partnerLevelList.length; i++) {
            const item = this.partnerLevelList[i]
            const code = item.code
            const codeName = item.codeName

            if (!partnerObj[code]) {
              partnerObj[code] = codeName
            }
          }

          this.partnerLevelObject = partnerObj
        }
      })
    },
    onChangeDateTable (value) {
      this.reqData.startDate = getDateStr(new Date(value.startDate))
      this.reqData.endDate = getDateStr(new Date(value.endDate))
    },
    async loadData (memId, page, type) {
      if (!page) {
        page = this.pageInfo.page
      } else {
        this.pageInfo.page = page
      }
      this.emitter.emit('Loading', true)

      if (memId) {
        this.reqData.memId = memId
      }

      const params = { ...this.reqData, page: page, count_per_list: 40 }
      // console.log('데이터 ::::', params)
      if (this.orderStr) {
        const orderColumn = this.orderStr.split('_')[0]
        const orderType = this.orderStr.split('_')[1]

        params.orderColumn = orderColumn
        params.orderType = orderType
      }

      await retailMyPartnerCashList(params, type).then(res => {
        this.emitter.emit('Loading', false)
        const data = res.data.data
        this.cashList = []

        if (data) {
          this.cashList = data.list

          if (data.pageInfo) {
            this.pageInfo = data.pageInfo
          } else {
            this.pageInfo.page = 1
            this.pageInfo.tatal_list_count = 0
          }
        }
      })
    }
  }
}
</script>

<style src="@/styles/striNew.css"></style>
<style scoped>
#PTtab-5 {
  min-height: calc(100vh - 52px);
  padding: 22px 18px 42px;
  box-sizing: border-box;
  background: #f4f7fb;
  color: #111827;
}

#PTtab-5 .tablist {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 18px;
  padding: 0;
  list-style: none;
}

#PTtab-5 .tabmenu {
  min-width: 118px;
  height: 38px;
  padding: 0 18px;
  border: 1px solid #d8e0ed;
  border-radius: 6px;
  background: #fff;
  color: #111827;
  font-size: 16px;
  font-weight: 800;
  line-height: 38px;
  text-align: center;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
  box-sizing: border-box;
}

#PTtab-5 .tabmenu.current,
#PTtab-5 .tabmenu:hover {
  border-color: #4f66d8;
  background: #4f66d8;
  color: #fff;
  box-shadow: 0 6px 14px rgba(79, 102, 216, 0.22);
}

#PTtab-5 .pagenamPT {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 14px;
}

#PTtab-5 .pagename2 {
  margin: 0;
  color: #0f172a;
  font-size: 22px;
  font-weight: 900;
  letter-spacing: -0.8px;
}

#PTtab-5 .sch_PC,
#PTtab-5 .sch_Normal {
  margin-bottom: 12px;
  padding: 14px 16px;
  border: 1px solid #d9e3f2;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.04);
  box-sizing: border-box;
}

#PTtab-5 .sch_M {
  display: none;
}

#PTtab-5 .PTsch,
#PTtab-5 .sch_Btm,
#PTtab-5 .searchPTwrap,
#PTtab-5 .searchPT,
#PTtab-5 .datesearchPT,
#PTtab-5 .datesearchPTWarp {
  display: flex;
  align-items: center;
  gap: 8px;
}

#PTtab-5 .flex-c {
  flex-direction: column;
  align-items: flex-start;
}

#PTtab-5 .gap-2 {
  gap: 4px;
}

#PTtab-5 .PTsch {
  width: 100%;
  margin: 0;
}

#PTtab-5 .sch_Btm {
  width: 100%;
  margin: 0;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px 18px;
}

#PTtab-5 .searchPTwrap {
  width: auto;
  justify-content: flex-start;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 10px 14px;
}

#PTtab-5 .searchPT {
  justify-content: flex-start;
  align-items: flex-end;
  gap: 10px;
}

#PTtab-5 .datesearchPT h4,
#PTtab-5 .datesearchPTWarp h4 {
  margin: 0 0 3px;
  color: #374151;
  font-size: 12px;
  font-weight: 900;
  line-height: 1.2;
  white-space: nowrap;
}

#PTtab-5 .h36px,
#PTtab-5 .searchPT input,
#PTtab-5 .searchPT select,
#PTtab-5 .datesearchPT select {
  height: 34px !important;
  min-width: 120px;
  padding: 0 10px !important;
  border: 1px solid #d6deeb !important;
  border-radius: 7px !important;
  background: #fff !important;
  color: #111827 !important;
  font-size: 13px !important;
  box-sizing: border-box;
}

#PTtab-5 .searchPT input {
  width: 210px;
}

#PTtab-5 .datesearchPT.w30p {
  width: auto !important;
}

#PTtab-5 .sch_Icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  margin: 0;
  border-radius: 7px;
  background: #344054;
  cursor: pointer;
}

#PTtab-5 .sch_Icon img {
  width: 15px;
  height: 15px;
  object-fit: contain;
}

#PTtab-5 :deep(.datesearch) {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  margin: 0 !important;
  background: transparent !important;
}

#PTtab-5 :deep(.datesearch span) {
  color: #111827 !important;
}

#PTtab-5 :deep(input[type="date"]),
#PTtab-5 :deep(.datesearch input) {
  width: 132px !important;
  min-width: 132px !important;
  height: 34px !important;
  margin: 0 !important;
  padding: 0 10px !important;
  border: 1px solid #d6deeb !important;
  border-radius: 7px !important;
  background-color: #fff !important;
  color: #111827 !important;
  font-size: 13px !important;
  box-sizing: border-box;
}

#PTtab-5 :deep(.dateBtn),
#PTtab-5 :deep(.bga) {
  min-width: 54px !important;
  height: 34px !important;
  margin: 0 !important;
  padding: 0 12px !important;
  border: 0 !important;
  border-radius: 7px !important;
  background: #2f6fec !important;
  color: #fff !important;
  font-size: 13px !important;
  font-weight: 900 !important;
  line-height: 34px !important;
  cursor: pointer;
  box-shadow: 0 3px 8px rgba(47, 111, 236, 0.22);
}

#PTtab-5 :deep(input[type="checkbox"]) {
  width: 14px !important;
  min-width: 14px !important;
  height: 14px !important;
  min-height: 14px !important;
  padding: 0 !important;
  margin: 0;
  accent-color: #2f6fec;
}

#PTtab-5 :deep(label) {
  color: #374151;
  font-size: 12px;
  font-weight: 700;
}

#PTtab-5 .cashTreeMobileBtn,
#PTtab-5 .cashCardM {
  display: none;
}

#PTtab-5 .strTableWrap {
  display: grid;
  grid-template-columns: 260px minmax(0, 1fr);
  gap: 18px;
  align-items: flex-start;
  width: 100%;
  min-height: auto;
  margin-top: 14px;
}

#PTtab-5 .cashTreeWrap,
#PTtab-5 .strTableWrap > .subMemWrap {
  width: 260px !important;
  min-width: 260px !important;
  max-width: 260px !important;
  min-height: 218px;
  padding: 14px 14px 18px !important;
  border: 1px solid #d9e3f2;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.04);
  box-sizing: border-box;
}

#PTtab-5 .cashTreeWrap .p10 {
  display: none;
}

#PTtab-5 .subPT_1 {
  min-height: auto;
  margin: 0;
  padding: 0;
  background: transparent;
  list-style: none;
}

#PTtab-5 .subPT_1 h3 {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0 0 12px;
  padding: 0;
  color: #1f2937;
  font-size: 14px;
  font-weight: 900;
  line-height: 1.3;
}

#PTtab-5 .subPT_1 h3 span {
  display: none;
}

#PTtab-5 .subPT_1 li {
  position: relative;
  margin: 7px 0;
  padding-left: 20px;
  color: #1f2937;
  font-size: 13px;
}

#PTtab-5 .subPT_1 a {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-height: 24px;
  padding: 0;
  color: #1f2937;
  cursor: pointer;
}
#PTtab-5 .subPT_1 a.pd-x-5{ padding: 0 5px; color: #fff;}
#PTtab-5 .subPT_1 a.active {
  color: #2f6fec;
  font-weight: 900;
}

#PTtab-5 .subPT_2,
#PTtab-5 .subPT_3,
#PTtab-5 .subPT_4 {
  margin: 6px 0 0 12px;
  padding: 0;
  list-style: none;
}

#PTtab-5 .arr {
  left: 0;
  top: 5px;
}

#PTtab-5 .allBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto;
  height: 20px;
  padding: 0 7px;
  border: 0;
  border-radius: 5px;
  background: #e53935;
  color: #fff;
  font-size: 11px;
  font-weight: 800;
  box-shadow: none;
}

#PTtab-5 .strTablescr {
  width: 100%;
  min-width: 0;
  overflow-x: auto;
  border: 1px solid #d9e3f2;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.04);
}

#PTtab-5 .strTablescr > div {
  overflow-x: visible;
  white-space: normal;
}

#PTtab-5 .strTablePC {
  display: block;
  width: 100%;
  min-width: 1000px;
}

#PTtab-5 .strTablePT {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
  border-top: 3px solid #2f6fec;
  border-radius: 12px 12px 0 0;
  overflow: hidden;
  color: #111827;
}

#PTtab-5 .strTablePT thead th {
  height: 43px;
  padding: 8px 10px;
  border-bottom: 1px solid #dfe7f2;
  background: #f6f9fd;
  color: #0f172a;
  font-size: 13px;
  font-weight: 900;
  text-align: center;
  line-height: 1.35;
  white-space: normal;
}

#PTtab-5 .strTablePT tbody td {
  min-height: 52px;
  padding: 13px 10px;
  border-bottom: 1px solid #e7edf5;
  background: #fff;
  color: #1f2937;
  font-size: 13px;
  text-align: center;
  line-height: 1.4;
  vertical-align: middle;
  word-break: break-all;
  white-space: normal;
}

#PTtab-5 .strTablePT tbody tr:nth-child(even) td {
  background: #fbfcff;
}

#PTtab-5 .strTablePT tbody tr:hover td {
  background: #f4f8ff;
}

#PTtab-5 .box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 34px;
  width: auto;
  height: 20px;
  padding: 0 7px;
  border-radius: 4px;
  color: #fff !important;
  font-size: 11px;
  font-weight: 800;
  line-height: 20px;
  white-space: nowrap;
  box-sizing: border-box;
}

#PTtab-5 .nick {
  color: #ff7e00 !important;
  font-weight: 800;
}

#PTtab-5 .plusAmt,
#PTtab-5 .blc {
  color: #2563eb !important;
  font-weight: 800;
}

#PTtab-5 .minusAmt,
#PTtab-5 .rdc {
  color: #ff6b00 !important;
  font-weight: 800;
}

#PTtab-5 .topwrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  height: 24px;
  margin: 0 auto;
  border: 1px solid #cfd8e6;
  border-radius: 5px;
  background: #fff;
  box-shadow: none;
}

#PTtab-5 .topwrap select.upperUser {
  width: 100%;
  height: 22px !important;
  min-width: 0 !important;
  padding: 0 6px !important;
  border: 0 !important;
  background: transparent !important;
  color: #475569;
  font-size: 11px !important;
}

#PTtab-5 .topwrap .icon {
  right: 4px;
  top: 4px;
  width: 14px;
  height: 14px;
  border-radius: 3px;
  background: #6b7280;
  color: #fff;
  font-size: 12px;
  font-weight: 900;
}

#PTtab-5 .partnerPaging {
  margin-top: 18px;
}

@media (max-width: 1280px) {
  #PTtab-5 .sch_Btm {
    justify-content: flex-start;
  }

  #PTtab-5 .searchPTwrap {
    width: 100%;
  }
}

@media (max-width: 1000px) {
  #PTtab-5 {
    padding: 14px 12px 30px;
  }

  #PTtab-5 .tablist {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }

  #PTtab-5 .tabmenu {
    min-width: 0;
    width: calc(50% - 4px);
    height: 38px;
    padding: 0 8px;
    font-size: 14px;
    line-height: 38px;
  }

  #PTtab-5 .pagenamPT {
    margin-bottom: 12px;
  }

  #PTtab-5 .sch_PC {
    display: none;
  }

  #PTtab-5 .sch_M {
    display: block;
    margin-bottom: 12px;
    padding: 14px;
    border: 1px solid #d9e3f2;
    border-radius: 12px;
    background: #fff;
  }

  #PTtab-5 .sch_Normal {
    padding: 14px;
  }

  #PTtab-5 .sch_Btm,
  #PTtab-5 .searchPTwrap {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  #PTtab-5 .searchPT {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    width: 100%;
  }

  #PTtab-5 .searchPT:last-child {
    grid-template-columns: 1fr 40px;
  }

  #PTtab-5 .searchPT input,
  #PTtab-5 .searchPT select,
  #PTtab-5 .datesearchPT select,
  #PTtab-5 .datesearchPT input {
    width: 100% !important;
    min-width: 0 !important;
  }

  #PTtab-5 .strTableWrap {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  #PTtab-5 .cashTreeMobileBtn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 42px;
    padding: 0 15px;
    margin-bottom: 6px;
    border-radius: 8px;
    background: #334155;
    color: #fff;
    font-size: 14px;
    font-weight: 900;
    cursor: pointer;
  }

  #PTtab-5 .cashTreeMobileBtn::after {
    content: '›';
    font-size: 22px;
  }

  #PTtab-5 .cashTreeWrap {
    display: none;
  }

  #PTtab-5 .cashTreeWrap.open {
    display: block;
    width: 100% !important;
    min-width: 0 !important;
    max-width: none !important;
    min-height: auto;
    max-height: 420px;
    overflow-y: auto;
  }

  #PTtab-5 .strTablescr {
    width: 100%;
    overflow: visible;
    border: 0;
    background: transparent;
    box-shadow: none;
  }

  #PTtab-5 .strTablePC {
    display: none;
  }

  #PTtab-5 .cashCardM {
    display: flex;
    flex-direction: column;
    gap: 14px;
    width: 100%;
  }

  #PTtab-5 .cashCard,
  #PTtab-5 .cashCardEmpty {
    border: 1px solid #d9e3f2;
    border-radius: 14px;
    background: #fff;
    box-shadow: 0 8px 22px rgba(15, 23, 42, 0.05);
    overflow: hidden;
  }

  #PTtab-5 .cashCardHead {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 14px 15px;
    background: #f6f9fd;
    border-bottom: 1px solid #e5edf7;
  }

  #PTtab-5 .cashCardHead strong {
    display: block;
    color: #111827;
    font-size: 16px;
    line-height: 1.2;
  }

  #PTtab-5 .cashCardHead span:not(.box) {
    display: block;
    margin-top: 3px;
    color: #ff7e00;
    font-size: 13px;
    font-weight: 900;
  }

  #PTtab-5 .cashCardBody {
    padding: 6px 14px;
  }

  #PTtab-5 .cashCardBody .row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    min-height: 42px;
    padding: 7px 0;
    border-bottom: 1px solid #eef2f7;
    font-size: 13px;
  }

  #PTtab-5 .cashCardBody .row:last-child {
    border-bottom: 0;
  }

  #PTtab-5 .cashCardBody .row em {
    flex: 0 0 96px;
    color: #64748b;
    font-size: 12px;
    font-weight: 900;
    line-height: 1.3;
  }

  #PTtab-5 .cashCardBody .row span,
  #PTtab-5 .cashCardBody .row > div {
    flex: 1;
    text-align: right;
    justify-content: flex-end;
    color: #111827;
    font-weight: 700;
    word-break: break-all;
  }

  #PTtab-5 .cashCardEmpty {
    padding: 34px 12px;
    color: #64748b;
    text-align: center;
  }
}
</style>
